import React, { Fragment } from "react";
import { Pagination } from "@mui/material";

const CustomPagination = ({ totalRows, rowsPerPage, page, handlePage }) => {
  const startRecord = totalRows !== 0 ? (page - 1) * rowsPerPage + 1 : 0;
  const endRecord = totalRows !== 0 ? Math.min(page * rowsPerPage, totalRows) : 0;
    return (
      <Fragment>
        {totalRows !== 0 ? <div className="paginator_block mt-3">
          <nav aria-label="Page navigation example">
            <p style={{ marginBottom: totalRows > rowsPerPage ? "10px" : "0" }}>
              Showing {startRecord || 0} - {endRecord || 0} of {totalRows || 0}
            </p>
            <Pagination
              page={page}
              count={Math.ceil(totalRows / rowsPerPage)}
              color="primary"
              boundaryCount={1}
              onChange={(event, value) => handlePage(value)}
            />
          </nav>
        </div> : null}
      </Fragment>
    );
};

export default CustomPagination;
